<div class="top-container">
  <h2>{{'mpupTransactions.transactionsHeading' | mbTranslate}}{{'main MPUP'}}</h2>
  <mb-mpup-search (search)="searchTransactionsList($event)" [placeholder]="'mpupTransactions.placeholder' | mbTranslate"></mb-mpup-search>

  <div class="filters">
    <mb-mpup-filter
      [filterName]="'mpupTransactions.transactionTypeFilterName' | mbTranslate"
      [filterOptions]="transactionTypes"
      (filter)="filter($event, 'type')"
    >
    </mb-mpup-filter>
    <mb-mpup-filter
      [filterName]="'mpupTransactions.passFilterName' | mbTranslate"
      [filterOptions]="transactionTypes"
      (filter)="filter($event, 'accessPassOwner')"
    >
    </mb-mpup-filter>
  </div>

</div>
<div class="transaction-list-container">
  <mb-mpup-transaction-list-item *ngFor="let item of listItems" [item]="item"></mb-mpup-transaction-list-item>
</div>

<div class="pagination-wrapper">
  <p>{{listItems?.length}} of {{pagination.getValue().totalResults}} {{'mpupTransactions.transactions' | mbTranslate}}</p>
  <cx-pagination [pagination]="pagination.getValue()" (viewPageEvent)="changePage($event)"></cx-pagination>
</div>

<div class="contact-container">
  <mb-mpup-contact-info></mb-mpup-contact-info>
</div>
